import React from 'react';
import SEO from '../components/SEO';
import './StaticPages.css';

function PrivacyPage() {
  return (
    <main className="static-page">
      <SEO 
        title="Privacy Policy - E Media Forum"
        description="Privacy Policy for E Media Forum - Learn how we collect, use, and protect your personal information."
      />
      
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 2025</p>
      </div>
      
      <div className="page-content">
        <section className="content-section">
          <h2>Information We Collect</h2>
          <p>
            E Media Forum may collect information you provide directly to us, such as when you 
            subscribe to our newsletter, contact us, or interact with our content.
          </p>
          <p>
            We may also automatically collect certain information about your device and usage 
            of our website through cookies and similar technologies.
          </p>
        </section>
        
        <section className="content-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Send you newsletters and updates (with your consent)</li>
            <li>Respond to your inquiries and requests</li>
            <li>Analyze website usage and performance</li>
            <li>Ensure website security and prevent fraud</li>
          </ul>
        </section>
        
        <section className="content-section">
          <h2>Information Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except as described in this policy or as required by law.
          </p>
          <p>
            We may share aggregated, non-personally identifiable information for analytics and 
            research purposes.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Cookies and Tracking</h2>
          <p>
            Our website uses cookies to enhance your browsing experience, analyze site traffic, 
            and understand where our visitors are coming from. You can control cookie settings 
            through your browser preferences.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>
        
        <section className="content-section">
          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for 
            the privacy practices or content of these external sites.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Changes to Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any 
            significant changes by posting the new policy on this page.
          </p>
        </section>
        
        <section className="content-section">
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at info@emediaforum.com
          </p>
        </section>
      </div>
    </main>
  );
}

export default PrivacyPage;